export default __webpack_public_path__ + "static/media/updateIcon.1daf5123.svg";